import { FaFileUpload } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import Usedragdrop from "../../../../customHooks/useDragdrop";
import { importEmployees } from "../../../../store/employee";
import { useAppDispatch } from "../../../../store/hooks";
import { useEffect } from "react";

interface Props {
  toggle: any;
  status: string;
}

const FileImport = ({ toggle, status }: Props) => {
  const dispatch = useAppDispatch();
  const {
    refInput,
    onChangefile,
    dragStatus,
    files,
    onDelete,
    errorFile,
    onClickDrag,
    onDrop,
    onDragOver,
    onDragLeave,
  } = Usedragdrop();

  const submitEmployees = () => {
    dispatch(importEmployees(files[0].file));
  };

  useEffect(() => {
    if (
      status === "importEmployees_success" ||
      status === "importEmployees_rejected"
    ) {
      onDelete(files[0].uuid);
    }
  }, [status]);

  return (
    <>
      <div className="c-form-report">
        <div
          className={`
            c-form-report__attachments 
            ${dragStatus && "c-form-report__attachments--dragover"} 
            ${errorFile && "c-form-report__attachments--error"}
          `}
          onClick={onClickDrag}
          onDrop={(e) => onDrop(e, 1)}
          onDragOver={(e) => onDragOver(e)}
          onDragLeave={(e) => onDragLeave(e)}
        >
          <span className="c-form-report__icon">
            <FaFileUpload />
          </span>
          <div className="c-form-report__info">
            <span
              className={`c-form-report__info-title ${
                errorFile && "c-form-report__info-title--error"
              }`}
            >
              {errorFile
                ? errorFile
                : dragStatus
                ? "Drop your file"
                : "Drop file here or click to Upload."}
            </span>
            <span className="c-form-report__info-text">
              Files can only be excel or csv
            </span>
          </div>
          <input
            ref={refInput}
            type="file"
            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel/*"
            onChange={(e) => onChangefile(e, 1)}
          />
        </div>
        <div className="c-form-report__box-files">
          {files.map(({ file, uuid }) => (
            <div className="c-form-report__file-name" key={uuid}>
              {file.name}
              <span
                className="c-form-report__delete-file"
                onClick={() => onDelete(uuid)}
              >
                <IoIosClose />
              </span>
            </div>
          ))}
        </div>
        <div className="c-form-report__footer">
          <button
            className="c-form-report__button-cancel c-form-report__button-cancel--left"
            onClick={toggle}
          >
            Cancel
          </button>
          <button
            className="c-form-report__button-submit"
            onClick={submitEmployees}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default FileImport;
